<div class="container mb-5 px-4">
  <h2>Om bordvers.dk</h2>
  <p>Bordvers.dk er skabt som et hobby-projekt, der skal gøre det nemt at slå op i en samlet oversigt over forskellige bordvers.</p>

  <h3 class="h4 mt-4">Hvorfor synger vi bordvers?</h3>
  <p>Et bordvers er et vers vi sammen synger til Gud, før vi deler maden med hinanden. Vi synger til Gud af taksigelse, fordi han altid sørger for os, og fordi han har velsignet os med maden.</p>
</div>